'use strict'

export default [
  {
    name:"background",
    fields: [
      { name:"background", height:5 },
      { name:"timing", height:5 },
      { name:"bigPicture", height:5 }
    ]
  },
  {
    name:"objectives",
    fields:[
      { name:"benefitsDescription", height:3 },
      { name:"objectivesSummary", type:"table",
        columns: [
          { name:"pri", priority:true },
          { name:"name", dragable:true},
          { name:"description", editable:true},
          { name:"tolerance", editable:true}
        ]
      },
      { name:"objectives", height:5 }
    ]
  },
  {
    name:"scope",
    fields:[
      { name:"projectScope", type:"table",
        columns: [
          { name:"text", editable:true, dragable:true }
        ],
        includeEmptyLine:true
      },
      { name:"scopeExclusions", height:5 },
      { name:"outcomes", height:5 }
    ]
  },
  {
    name:"constraints",
    fields:[
      { name:"constraints", height:5 },
      { name:"assumptions", height:5 }
    ]
  },
  {
    name:"stakeholders",
    fields:[
      { name:"stakeholderDescription", height:5 },
      { name:"interfaces", height:5 }
    ]
  }
];



// WEBPACK FOOTER //
// ./views/definition/formDefinition.js